import { render, staticRenderFns } from "./ManageLayout.vue?vue&type=template&id=040f715c&scoped=true&"
import script from "./ManageLayout.vue?vue&type=script&lang=js&"
export * from "./ManageLayout.vue?vue&type=script&lang=js&"
import style0 from "./ManageLayout.vue?vue&type=style&index=0&id=040f715c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f715c",
  null
  
)

export default component.exports